import { api } from "@/lib/api";

export const crmApi = {
  meta: () => api.get("/crm/meta").then((r) => r.data),
  stats: () => api.get("/crm/stats").then((r) => r.data),
  list: (params) => api.get("/crm/enquiries", { params }).then((r) => r.data),
  get: (id) => api.get(`/crm/enquiries/${id}`).then((r) => r.data),
  create: (body) => api.post("/crm/enquiries", body).then((r) => r.data),
  update: (id, body) => api.put(`/crm/enquiries/${id}`, body).then((r) => r.data),
  setStatus: (id, status, lost_reason) => api.patch(`/crm/enquiries/${id}/status`, { status, lost_reason }).then((r) => r.data),
  addActivity: (id, body) => api.post(`/crm/enquiries/${id}/activities`, body).then((r) => r.data),
};

export const CRM_STATUS_STYLE = {
  New: "bg-slate-100 text-slate-700",
  Qualified: "bg-blue-50 text-blue-700 border border-blue-200",
  Quoted: "bg-indigo-50 text-indigo-700 border border-indigo-200",
  Won: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  Lost: "bg-rose-50 text-rose-700 border border-rose-200",
};
